export default "__VITE_ASSET__CCQRzbpb__"